module.exports = __webpack_public_path__ + "static/media/yinji.4565e227.mp4";